import {createSelector} from '@ngrx/store';
import {selectSchooldashboard} from '../../../state/app.state';

export const selectLoadMedewerkers = createSelector(
  selectSchooldashboard,
  ({loadMedewerkers, loadDocenten, docenten}) => loadMedewerkers && !loadDocenten && Object.entries(docenten).length > 0
);
